export const formatCurrency = (
  value?: number,
  currency: string = "USD",
  locale: string = "en-US",
  minimumFractionDigits: number = 2
) => {
  if (value == null || isNaN(value)) return "-";

  const formatted = new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    minimumFractionDigits,
    maximumFractionDigits: minimumFractionDigits,
  }).format(value);

  return formatted.replace(/^(\D+)/, "$1 ");
};